/**
 * Proveniência da Pendency — QUEM prometeu, e de onde o registro veio.
 *
 * Casa única dessa tradução (spec `2026-08-14-aba-acoes-conversa-em-curso-design.md` §5.3).
 *
 * **Mora em `@lume/shared` desde 15/Ago/2026** (fatia M3 do mobile). Nasceu privada no
 * web; quando o app móvel precisou da MESMA etiqueta, copiar teria criado a terceira
 * cópia da régua — a dívida que [3.766] acabou de pagar para eliminar nos 4 estados
 * terminais e no formatador de prazo. Os RÓTULOS vêm junto de propósito: precedente
 * `worklist/greeting.ts`, que já devolve «Bom dia» daqui. Duas telas que dizem coisas
 * diferentes sobre quem prometeu seriam duas verdades sobre o mesmo campo.
 * O `Pendency.source` já vem no wire (`SerializedPendency.source`), assim como o `aiAgentId`;
 * nenhuma tabela ou campo novo é necessário para distinguir a promessa do OPERADOR da
 * promessa do CLIENTE — a distinção é um CAMPO, não uma segunda casa. Foi o que fechou a
 * conflação histórica entre `CustomerCommitment` (ADR-105, sem produtor no motor) e
 * `Pendency(source='conversation-promise')` da Corrente de Compromissos.
 *
 * **Degradação honesta é a regra central aqui.** `source` é string livre no backend e há ~10
 * subsistemas que criam Pendency (coleta estruturada, runbooks, no-show, import de cadastro,
 * confirmação de agendamento, mudança cadastral…). Qualquer valor fora dos três conhecidos
 * NÃO ganha rótulo de promessa: dizer «você prometeu» sobre uma pendência que o sistema criou
 * sozinho seria afirmar o que não se sabe. E `aiAgentId` presente NÃO basta para virar
 * promessa — vários desses subsistemas gravam agente sem que ninguém tenha prometido nada.
 */
/** Promessa do OPERADOR (ou da IA) AO cliente — Corrente de Compromissos S2. */
const CONVERSATION_PROMISE = 'conversation-promise';
/** Promessa do CLIENTE ao operador — nasce do `+ registrar` (e, adiante, da captura inbound). */
const CUSTOMER_PROMISE = 'customer-promise';
/** Registro à mão do operador (modal do header ou tela de Pendências). */
const MANUAL = 'manual';
export function provenanceOf(source, aiAgentId) {
    const captured = aiAgentId !== null;
    if (source === CONVERSATION_PROMISE) {
        return {
            who: 'me',
            whoLabel: 'você prometeu',
            originLabel: captured ? 'da sua fala' : null,
        };
    }
    if (source === CUSTOMER_PROMISE) {
        return {
            who: 'client',
            whoLabel: 'o cliente prometeu',
            originLabel: captured ? 'da fala dele' : null,
        };
    }
    if (source === MANUAL) {
        return { who: 'hand', whoLabel: 'você registrou', originLabel: null };
    }
    return { who: 'hand', whoLabel: 'registrada pelo sistema', originLabel: null };
}
//# sourceMappingURL=provenance.js.map